<!-- ----------------------------------------------- -->
<template>
  <v-card class="com-mb-card tm-mb-info-card">
    <v-row class="com-mb-card-contents" no-gutters>
      <v-expansion-panels accordion class="tm-mb-obs-panel">
        <v-expansion-panel>
          <v-expansion-panel-header class="tm-mb-obs-panel-header" expand-icon="arrow_drop_down">
            <v-row no-gutters>
              <v-row class="tm-mb-obs-panel-content" no-gutters>
                <div class="tm-mb-obs-panel-item">
                  <span class="tm-mb-rvrnm">
                    {{ tmCoastList.tmCoastDetailInfo.obsNm }}
                  </span>
                </div>
                <div class="tm-mb-obs-panel-item">
                  <span class="tm-mb-rvrnm">
                    {{ tmCoastList.tmCoastDetailInfo.rsysNm }}{{ text.rsys }}
                  </span>
                </div>
                <div class="tm-mb-obs-panel-item">
                  <span class="tm-mb-rvrnm">
                    {{ tmCoastList.tmCoastDetailInfo.rvrNm }}
                  </span>
                </div>
              </v-row>
              <v-row no-gutters class="tm-mb-curt-time"
                >{{ text.obsTime }} {{ tmCoastList.curt.obsTime }}</v-row
              ></v-row
            >
          </v-expansion-panel-header>
          <v-expansion-panel-content class="tm-mb-obs-content">
            <v-list dense class="tm-mb-obs-content-v-list">
              <!-- 観測所情報 -->
              <v-list-item
                v-for="(item, index) in tmCoastList.obsInfo"
                :key="`obs-${index}`"
                class="tm-mb-obs-content-v-list-item"
                v-show="!item.notMb"
              >
                <v-list-item-content
                  class="tm-mb-obs-content-v-list-item-content"
                  >{{ item.title }}</v-list-item-content
                >
                <v-list-item-content
                  v-if="showQwtrDbBtn(item.qwtrObsCd, item.dbLink)"
                  class="tm-mb-obs-content-v-list-item-content"
                >
                  <span
                    class="tm-mb-link"
                    @click="openQwtrDb(item.qwtrObsCd)"
                    >{{ item.obsValue }}</span
                  >
                </v-list-item-content>
                <v-list-item-content
                  v-else
                  class="tm-mb-obs-content-v-list-item-content"
                >
                  <div>
                    <span class="list-value">{{ item.value }}</span>
                    <span class="list-unit">{{ item.unit }}</span>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <!-- 基準値(注意値) -->
              <v-list-item
                v-for="(item, index) in tmCoastList.standardValue"
                :key="`sd-${index}`"
                class="tm-mb-obs-content-v-list-item"
              >
                <v-list-item-content
                  class="tm-mb-obs-content-v-list-item-content"
                  >{{ item.title }}</v-list-item-content
                >
                <v-list-item-content
                  class="tm-mb-obs-content-v-list-item-content"
                >
                  <div>
                    <span class="list-value">{{ item.value }}</span>
                    <span class="list-unit">{{ item.unit }}</span>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <!-- 基準値(警戒値) -->
              <v-list-item
                v-for="(item, index) in tmCoastList.standardWarningValue"
                :key="`sdw-${index}`"
                class="tm-mb-obs-content-v-list-item"
              >
                <v-list-item-content
                  class="tm-mb-obs-content-v-list-item-content"
                  >{{ item.title }}</v-list-item-content
                >
                <v-list-item-content
                  class="tm-mb-obs-content-v-list-item-content"
                >
                  <div>
                    <span class="list-value">{{ item.value }}</span>
                    <span class="list-unit">{{ item.unit }}</span>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [MB]海岸 観測所情報カード
 * TmCoastInfo.vue
 * @author ILUKE
 */

export default {
  name: "tm-coast-info",
  data() {
    return {
      /** 文字列リソース */
      text: {
        info: "お知らせ",
        obsInfo: "観測所情報",
        obsTime: "最新観測値",
        obsType: "海岸",
        rsys: "水系",
      },
    };
  },
  created() {
    this.$store.dispatch("map/getObsInformation", {
      ofcCd: this.$store.state.Telemeter.selectedTmParam.ofcCd,
      itmkndCd: this.$store.state.Telemeter.selectedTmParam.itmkndCd,
      obsCd: this.$store.state.Telemeter.selectedTmParam.obsCd,
    });
  },
  computed: {
    /**
     * 海岸情報 取得
     */
    tmCoastList: {
      get() {
        return this.$store.state.Telemeter.selectedTm;
      },
    },
    /**
     * お知らせ情報の中で緊急度が一番高い１レコードのみ取得
     */
    tmInfo: {
      get() {
        return this.$store.state.map.tmInfo;
      },
    },
  },
  methods: {
    showQwtrDbBtn(qwtrObsCd, dbLink) {
      if (qwtrObsCd !== null && qwtrObsCd !== undefined && dbLink === 1) {
        return true;
      } else {
        return false;
      }
    },
    openQwtrDb(qwtrObsCd) {
      let link =
        this.$store.state.app.config.appConfig.linkUrls.qwtrDbLink + qwtrObsCd;
      window.open(link);
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
